import { useState } from 'react'
import classNames from 'classnames'
import { DateTime } from 'luxon'

import { MAX_VESIS_WEEKS, MOBILE_WIDTH_BREAKPOINT } from '~/lib/constants'
import { useMediaQuery } from '~/hooks/useMediaQuery'
import { useVESISParams } from '~/hooks/useVESISParams'

import { SimpleMode } from './SimpleMode'
import { AdvanceMode } from './AdvanceMode'

import ChevronIcon from './assets/chevron.svg'

import styles from './ExpiresDate.pcss'
import { patchExpiresDate } from '~/lib/patchExpiresDate'

interface Props {
	className?: string
	disabled?: boolean
	min?: number
	value: number
	addWeek?: number
	onChange: (weeks: number) => void
}

export function ExpiresDate({
	className,
	disabled,
	min,
	value,
	addWeek,
	onChange,
}: Props) {
	const { config } = useVESISParams()

	const isMobile = useMediaQuery(`(max-width: ${MOBILE_WIDTH_BREAKPOINT}px)`)

	const [advanceMode, setAdvanceMode] = useState(false)

	const minDate = min ? DateTime.fromSeconds(min) : DateTime.now()
	let expiresDate = minDate.plus({ weeks: value })
	if (value < MAX_VESIS_WEEKS && addWeek) {
		expiresDate = expiresDate.plus({ weeks: addWeek })
	}

	let availableWeeks = MAX_VESIS_WEEKS
	if (min) {
		const nowDate = DateTime.now()
		const endDate = DateTime.fromSeconds(min)
		const remainingWeeks = Math.ceil(endDate.diff(nowDate).as('weeks'))

		availableWeeks = Math.floor(MAX_VESIS_WEEKS - remainingWeeks)
	}

	return (
		<div className={classNames(styles.container, className)}>
			<div className={styles.title}>
				<div>
					Expires Date
					{!isMobile && (
						<>
							:{' '}
							<span className={styles.value}>
								{patchExpiresDate(
									config,
									expiresDate
								).toLocaleString()}
							</span>
						</>
					)}
				</div>
				<button
					className={styles.advanceModeButton}
					type="button"
					onClick={() => {
						setAdvanceMode((mode) => !mode)
						onChange(0)
					}}
				>
					<span>Advance mode</span>
					<ChevronIcon
						className={classNames(
							styles.chevron,
							advanceMode && styles.advance
						)}
					/>
				</button>
			</div>
			{advanceMode ? (
				<AdvanceMode
					availableWeeks={availableWeeks}
					disabled={disabled}
					className={styles.advanceMode}
					value={value}
					onChange={onChange}
				/>
			) : (
				<SimpleMode
					availableWeeks={availableWeeks}
					disabled={disabled}
					className={styles.simpleMode}
					value={value}
					onChange={onChange}
				/>
			)}
			{isMobile && (
				<div className={styles.value}>
					Expires till:{' '}
					{patchExpiresDate(config, expiresDate).toLocaleString()}
				</div>
			)}
		</div>
	)
}
